<template>
    <iframe
        v-if="consent"
        :title="title"
        :class="classes"
        :src="
            'https://www.youtube.com/embed/' +
            youtubeId +
            '?rel=0&modestbranding=1&playsinline=1&info=0'
        "
        :allow="allow">
    </iframe>
    <slot v-else>
        <div
            class="container flex h-full w-full items-center justify-center bg-purple-100 py-36 lg:px-8">
            <div class="w-full max-w-2xl bg-black px-14 py-10 text-white">
                <h3>{{ consentTitle }}</h3>
                <p class="mb-8 mt-4">{{ consentDescription }}</p>
                <button
                    @click="enableYoutube"
                    class="group inline-flex items-center justify-center whitespace-normal">
                    <span>{{ consentButtonLabel }}</span>
                    <div class="ml-2 h-5 w-14 shrink-0">
                        <lz-icon
                            name="arrow"
                            class="h-6 w-12 stroke-white stroke-2 transition-transform group-hover:translate-x-2" />
                    </div>
                </button>
            </div>
        </div>
    </slot>
</template>

<script lang="ts" setup>
import { defineProps, onMounted, ref } from 'vue';
import services from '@/components/cookies/services';
import LzIcon from '@/components/base/LzIcon.vue';
import events from '@/events';

const props = defineProps<{
    title: string;
    youtubeId: string;
    classes: string;
    allow: string;
    consentTitle: string;
    consentDescription: string;
    consentButtonLabel: string;
}>();

const consent = ref(false);

onMounted(() => {
    window.addEventListener(`consent-${services.youtube}`, (e: Event) => {
        consent.value = !!(e as CustomEvent).detail.consent;
    });
});

function enableYoutube() {
    events.$emit('enable-cookies', services.youtube);
}
</script>
